import logger, { initLogger } from '@/utils/logger.js'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  initLogger({ datadogAppId: config.public.DATADOG_APP_ID })

  const { clearAllCookies } = useApolloToken()

  const customFetch = $fetch.create({
    onRequest({ options }) {
      // Attach timestamp to request options for duration calculation
      ;(options as any).__requestStartedAt = Date.now()
    },
    onResponseError({ response, request, options }) {
      // Get URL from request (can be string or Request object)
      const url = typeof request === 'string' ? request : request.url || options.baseURL || 'unknown'

      const requestUrl = import.meta.client ? window.location.href :
        nuxtApp.ssrContext?.event?.node.req.originalUrl ||
        nuxtApp.ssrContext?.event?.node.req.url

      // Get method from options
      const method = (options.method || 'GET').toUpperCase()

      // Calculate duration from timestamp attached in onRequest
      const requestStartedAt = (options as any).__requestStartedAt
      const duration = requestStartedAt ? Date.now() - requestStartedAt : undefined

      const loggerPayload = {
        message: `[fetch] Error ${response.status} ${method} ${url}`,
        status: response.status,
        method,
        url,
        request_url: requestUrl,
        duration,
        context: '$fetch-response'
      }

      const is404 = response.status === 404
      const is401 = response.status === 401
      const is404ProneUrl = [/\/api\/v2\/users\/\d+\/data-request/].some(regex => regex.test(url))

      if (is404 && is404ProneUrl) {
        return
      }

      if (is401) {
        clearAllCookies()
      }

      logger.error(loggerPayload)
    }
  })

  // Override nuxtApp.$fetch so useFetch uses our custom instance
  nuxtApp.$fetch = customFetch

  // Also override global $fetch for direct calls
  globalThis.$fetch = customFetch
})
